<template>
  <svg
    id="b" class="mr-1" xmlns="http://www.w3.org/2000/svg" width="19" height="13"
    viewBox="0 0 33.25 20.88"
  >
    <rect y="10.08" width="33.23" height="10.77" fill="#fff" />
    <rect width="33.23" height="12.46" fill="#fff" />
    <rect width="33.23" height="2.93" fill="#dd3330" />
    <rect y="17.95" width="33.23" height="2.93" fill="#dd3330" />
    <rect y="5.94" width="33.25" height="8.86" fill="#2f4794" />
  </svg>
</template>
